import { api, unwrap } from './http';

export default {
  list: async (params = {}, config = {}) => unwrap(api.get('/Users', params, config)),

  getById: async (id, params = {}) => unwrap(api.get(`/Users/${id}`, params)),

  create: async (payload) => unwrap(api.post('/Users', payload)),

  update: async (id, payload) => unwrap(api.put(`/Users/${id}`, payload)),

  remove: async (id, params = {}) => unwrap(api.delete(`/Users/${id}`, params)),

  searchByFullName: async (fullName, extra = {}) => unwrap(api.get('/Users', { FullName: fullName, ...extra })),

  grantStaffAccess: async (payload) => unwrap(api.post('/Users/GrantStaffAccess', payload)),

  createProfessional: async (payload) => unwrap(api.post('/Users/CreateProfessional', payload)),

  grantProfessionalRole: async (payload) => unwrap(api.post('/Users/GrantProfessionalRole', payload)),

  removeProfessionalRole: async (payload) => unwrap(api.post('/Users/RemoveProfessionalRole', payload)),

  changeUserPassword: async (payload) => unwrap(api.put('/Users/ChangeUserPassword', payload)),

  resetUserPassword: async (payload) => unwrap(api.put('/Users/ResetUserPassword', payload)),

  updatePersonalSettings: async (payload) => unwrap(api.put('/Users/UpdatePersonalSettings', payload)),

  resetPassword: async (userid) => unwrap(api.put(`/Users/ResetUserPassword?userid=${encodeURIComponent(userid)}`)),

  // Admin email fix for a locked-out member. Returns { status }: 'EmailSet' (email set +
  // link sent) or 'EmailInUse' (belongs to another account — not linked; needs the owner's
  // consent — also returns accountName).
  correctMemberEmail: async (payload) => unwrap(api.post('/Users/CorrectMemberEmail', payload)),

  // Ask the account that owns the email to consent to linking this member. Nothing is linked
  // here — the owner gets an emailed Approve/Reject link. Returns { status:'ConsentRequested' }.
  requestMemberAccountLink: async (payload) => unwrap(api.post('/Users/RequestMemberAccountLink', payload)),

  getRoles: async (userId) => unwrap(api.get(`/Users/${userId}/roles`)),

  assignRoles: async (userId, payload) => unwrap(api.post(`/Users/${userId}/roles`, payload)),

  removeRole: async (userId, securityRoleId) => unwrap(api.delete(`/Users/${userId}/roles`, { SecurityRoleId: securityRoleId, UserId: userId })),

  // Branch access is one user-level set applied across every role the user holds.
  // An empty branchIds grants every branch.
  getBranchAccess: async (userId) => unwrap(api.get(`/Users/${userId}/branch-access`)),

  saveBranchAccess: async (userId, branchIds) => unwrap(api.put(`/Users/${userId}/branch-access`, { branchIds })),

  // Where a professional works — the set the Professionals grid shows. A different question from
  // branch access above: this one places them, that one lets them administer.
  getBranchAssignment: async (userId) => unwrap(api.get(`/Users/${userId}/branches`)),

  saveBranchAssignment: async (userId, branchIds) => unwrap(api.put(`/Users/${userId}/branches`, { branchIds })),

  // Which cash boxes this user may take money through. Unlike branch access an empty set means
  // none: an unassigned user cannot take a payment at all. The response carries the drawers the
  // administrator may hand out, because the plain cash box list is filtered to their own.
  getCashboxAccess: async (userId) => unwrap(api.get(`/Users/${userId}/cashbox-access`)),

  saveCashboxAccess: async (userId, cashBoxIds) => unwrap(api.put(`/Users/${userId}/cashbox-access`, { cashBoxIds })),
};
